module.exports = "<ng-container>\r\n    <navbar-vertical-style-1 class=\"green-400\"></navbar-vertical-style-1>\r\n</ng-container>\r\n\r\n"